<!-- Avalehe tagasisidede karussell -->
<template>
  <div class="feedback-carousel page-properties">
    <div class="feedback-header py-5">
      <div class="pr-3">
        <svg class="feedback-icon" viewBox="-2.4 -2.4 28.80 28.80" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M7 9H17M7 13H12M21 20L17.6757 18.3378C17.4237 18.2118 17.2977 18.1488 17.1656 18.1044C17.0484 18.065 16.9277 18.0365 16.8052 18.0193C16.6672 18 16.5263 18 16.2446 18H6.2C5.07989 18 4.51984 18 4.09202 17.782C3.71569 17.5903 3.40973 17.2843 3.21799 16.908C3 16.4802 3 15.9201 3 14.8V7.2C3 6.07989 3 5.51984 3.21799 5.09202C3.40973 4.71569 3.71569 4.40973 4.09202 4.21799C4.51984 4 5.0799 4 6.2 4H17.8C18.9201 4 19.4802 4 19.908 4.21799C20.2843 4.40973 20.5903 4.71569 20.782 5.09202C21 5.51984 21 6.0799 21 7.2V20Z" stroke="#3b71f7" opacity="80%" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
      </div>
      <h2>{{ $t('tagasiside') }}</h2>
      <v-btn class="ml-5" v-if="isLoggedIn" color="success" to="/addfeedback">lisa +</v-btn>
    </div>
    <v-slide-group :show-arrows="!xs">
      <v-slide-group-item v-for="feedback in feedbacks" :key="feedback.id">
        <a class="my-auto" v-if="isLoggedIn" :href="'/editfeedback/' + feedback.id">
          <i class="fa fa-cog" ></i>
        </a>
        <v-card hover class="d-flex flex-column align-center ma-4 feedback-slider" :width="width">
          <div class="pa-5">
            <svg width="64px" height="64px" viewBox="-2.4 -2.4 28.80 28.80" fill="none" xmlns="http://www.w3.org/2000/svg" transform="matrix(-1, 0, 0, 1, 0, 0)"><g id="SVGRepo_bgCarrier" stroke-width="0"><path transform="translate(-2.4, -2.4), scale(0.8999999999999999)" d="M16,29.847521620557497C18.030074747466145,29.52918299951166,18.364983679079426,26.35691083132207,20.19545249013762,25.423140576017104C21.892242718165775,24.557563279723876,24.511745015260118,26.22656710685002,25.817244853261858,24.83948696973913C27.10885484313195,23.467164653265264,26.26127921073013,21.117775149520075,26.00480870688977,19.25075940591096C25.802376730422917,17.777125278733635,24.071867885903316,16.538895637743863,24.48052877370202,15.108660508591486C25.231290448756827,12.481137901599114,29.077715904224277,11.173001882769759,29.09365911074956,8.44037238773155C29.105834081090403,6.353610041534399,26.393768917580502,5.206120857589243,24.543939085182252,4.2402767135481305C22.77765565563763,3.3180543138094434,20.685415650311203,3.532982644749495,18.754321527418373,3.041936010922866C16.74708915071314,2.531528625697952,14.742918682427053,0.38880035894157494,12.869386843445268,1.2716230825432007C10.787788551787528,2.252488331294193,11.241389877919705,5.615039115657293,9.688963236854544,7.313603099777675C8.517716136939342,8.595105289830535,6.402967095704856,8.539159947018621,5.139185151572622,9.729505623641762C3.735260926042658,11.05185014670232,2.3283384943882677,12.626492110383621,2.02601037978628,14.531274507356926C1.7236469896898554,16.436279153395414,2.4973723311960523,18.41349531354628,3.4992470677301846,20.06174084543572C4.441605822346608,21.612072987861687,6.185686794509056,22.41150155203943,7.545791028836124,23.612203948975026C8.772464607578979,24.69511352978582,9.857890295256386,25.866451523640297,11.174750218772756,26.837688451909642C12.717216197532013,27.975318880489915,14.106525961073643,30.1444397095541,16,29.847521620557497" fill="#3b71f7" opacity="80%" strokewidth="0"></path></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.2C21 14.8802 21 15.7202 20.673 16.362C20.3854 16.9265 19.9265 17.3854 19.362 17.673C18.7202 18 17.8802 18 16.2 18H13.6837C13.0597 18 12.7477 18 12.4492 18.0613C12.1844 18.1156 11.9282 18.2055 11.6875 18.3285C11.4162 18.4671 11.1725 18.662 10.6852 19.0518L8.29976 20.9602C7.88367 21.2931 7.67563 21.4595 7.50054 21.4597C7.34827 21.4599 7.20422 21.3906 7.10923 21.2716C7 21.1348 7 20.8684 7 20.3355V18C6.07003 18 5.60504 18 5.22354 17.8978C4.18827 17.6204 3.37962 16.8117 3.10222 15.7765C3 15.395 3 14.93 3 14V7.8Z" stroke="#000000" stroke-width="0.72" stroke-linecap="round" stroke-linejoin="round"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9969 7.69925C11.0972 6.6604 9.59689 6.38095 8.46961 7.33223C7.34234 8.2835 7.18364 9.87399 8.06889 10.9991C8.61733 11.6961 9.99389 12.9691 10.962 13.837C11.3176 14.1557 11.4953 14.3151 11.7087 14.3793C11.8918 14.4344 12.1021 14.4344 12.2851 14.3793C12.4985 14.3151 12.6763 14.1557 13.0319 13.837C13.9999 12.9691 15.3765 11.6961 15.9249 10.9991C16.8102 9.87399 16.6709 8.2735 15.5242 7.33223C14.3776 6.39096 12.8966 6.6604 11.9969 7.69925Z" stroke="#000000" stroke-width="0.72" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
            <p class="font-weight-bold font-italic"> "{{ getBody(feedback) }}" </p>
          </div>
        </v-card>
      </v-slide-group-item>
    </v-slide-group>
  </div>
</template>


<script setup>
import {useDisplay} from "vuetify";
import {computed} from "vue";

const { xs } = useDisplay()

const width = computed(() => {
  switch (name.value) {
    case 'xs': return 300
    case 'xxl': return 333
  }

  return undefined
})
</script>

<script>
export default {
  name: "FeedbackCarousel",
  data () {
    return {
      feedbacks: []
    }
  },
  methods: {
    fetchFeedbacks() {
      fetch(`${process.env.VUE_APP_SERVER_URL}/api/feedbacks/`)
          .then((response) => response.json())
          .then((data) => {
            this.feedbacks = data.reverse(); // uuemad eespool
          })
          .catch((err) => console.log(err.message));
    },
    getBody(content) {
      return (this.$i18n.locale === 'en' && content.body_en !== null) ? content.body_en : (this.$i18n.locale === 'ru' && content.body_ru !== null) ? content.body_ru : content.body;
    }
  },
  mounted() {
    this.fetchFeedbacks();
    console.log("mounted");
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
  }
}
</script>

<style scoped>
.feedback-slider {
  width: 333px;
}

.feedback-header {
  display: flex;
  align-items: center;
}

.feedback-icon {
  width: 120px;
  height: 120px;
}

@media (max-width: 820px) {
  .feedback-slider {
    width: 300px;
  }
  .feedback-header {
    justify-content: center;
  }
  .feedback-header h2 {
    font-size: 1.5em;
  }
  .feedback-icon {
    width: 100px;
    height: 100px;
  }
}
</style>